import {withJsonFormsLayoutProps} from '@jsonforms/react'
import CustomLayoutRenderer from '../CustomLayoutRenderer'

const HorizontalLayout = ({schema, uischema, path, renderers, cells, enabled, visible, label}) => {
  const layoutProps = {
    elements: uischema.elements,
    schema: schema,
    path: path,
    direction: 'row',
    gap: uischema.gap,
    visible: visible,
    uischema: uischema,
    renderers: renderers,
    label: label,
    cells: cells,
    enabled: enabled,
  }
  return <CustomLayoutRenderer {...layoutProps} />
}

export const HorizontalLayoutControl = withJsonFormsLayoutProps(HorizontalLayout)
